export default __webpack_public_path__ + "static/media/autosweep-rfid-paymentpage.e7c2bd4d.png";